class Auth {    
    isLoggedIn() {
        if(localStorage.getItem('authToken')){
            return true;
        }
        return false;
    }
    getRole() {
        try {
            const admin = JSON.parse(localStorage.getItem('admin') || '{}');
            return admin.role || 'subadmin';
        } catch(e) {
            return 'subadmin';
        }
    }
    isAdmin() {
        return this.getRole() === 'admin';
    }
    getPermissions() {
        try {
            const admin = JSON.parse(localStorage.getItem('admin') || '{}');
            return admin.permissions || {};
        } catch(e) {
            return {};
        }
    }
    // Returns true if super-admin OR sub-admin has the given permission
    hasPermission(moduleKey, action = 'read') {
        if (this.isAdmin()) return true;           // super-admin has all access
        const perms = this.getPermissions();
        return !!(perms[moduleKey] && perms[moduleKey][action]);
    }
}
export default new Auth();